<app-count-box
  [label]="title"
  [styleClass]="styleClass"
  mode="view"
  [count]="store.count()"
  [text]="text"
  icon="fas fa-ruler"
  severity="secondary" />
